import { makeDataObjGenerator } from 'mocks/helpers'
import { FastTrackPersonDetails } from 'types/global'

const defaultData: FastTrackPersonDetails = {
  alreadyItfCustomer: false,
  alreadyRegisteredForService: false,
  firstName: 'TestFirstname',
  lastName: 'TestLastname',
  birthDate: '2000-01-20',
}

export const createFastTrackDetails = makeDataObjGenerator(defaultData)
